import React from "react";
import { ImageComp } from "./ImageComp";

function ShowImg({ imgs, title }) {
  return (
    <>
      <ul>
        {imgs.map((i) => {
          return (
            <li key={i.id}>
              <ImageComp image={i} alt={`${title} Designs`} />
            </li>
          );
        })}
      </ul>
    </>
  );
}

export { ShowImg };
